export function getHubspotUtk(): string | null {
	const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]*)/)
	return match ? decodeURIComponent(match[1]) : null
}

export const HUBSPOT_ONBOARDING_BOOKING_URL =
	'https://meetings.hubspot.com/thabisile-khumalo/onboarding'

/**
 * Returns the HubSpot onboarding booking URL with any UTM parameters
 * from the current page's URL forwarded as query parameters.
 */
export function getOnboardingBookingUrl(): string {
	const currentParams = new URLSearchParams(window.location.search)
	const utmParams = new URLSearchParams()

	currentParams.forEach((value, key) => {
		if (key.startsWith('utm_')) {
			utmParams.set(key, value)
		}
	})

	const utmString = utmParams.toString()
	return utmString
		? `${HUBSPOT_ONBOARDING_BOOKING_URL}?${utmString}`
		: HUBSPOT_ONBOARDING_BOOKING_URL
}
